// ===== YUMYUM theme JS =====
(function(){
'use strict';

// ---- Scroll reveal ----
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

// ---- Money ----
const money = c => '$' + (c/100).toFixed(2).replace(/\.00$/,'');

// ---- Cart drawer ----
const drawer = document.getElementById('cartDrawer');
const overlay = document.getElementById('drawerOverlay');
const cartCount = document.getElementById('cartCount');
const FREE_SHIP = drawer ? parseInt(drawer.dataset.freeShipCents,10) : 5000;

function openDrawer(){ if(!drawer) return; drawer.classList.add('open'); overlay.hidden=false; drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; document.body.classList.add('drawer-open'); }
function closeDrawer(){ if(!drawer) return; drawer.classList.remove('open'); overlay.hidden=true; drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; document.body.classList.remove('drawer-open'); }
document.getElementById('cartOpen')?.addEventListener('click', ()=>{ refreshCart().then(openDrawer); });
document.getElementById('drawerClose')?.addEventListener('click', closeDrawer);
overlay?.addEventListener('click', closeDrawer);
document.addEventListener('keydown', e=>{ if(e.key==='Escape') closeDrawer(); });

function renderCart(cart){
  if(!drawer) return;
  cartCount.textContent = cart.item_count;
  const items = document.getElementById('drawerItems');
  const empty = document.getElementById('drawerEmpty');
  const upsell = document.getElementById('drawerUpsell');
  const totalEl = document.getElementById('drawerTotal');
  totalEl.textContent = money(cart.total_price);

  // free shipping progress (domestic AU only — international pays a flat rate, no free threshold)
  const domestic = (drawer.dataset.shipCountry || 'AU') === 'AU';
  const fill = document.getElementById('shipBarFill');
  const msg = document.getElementById('shipBarMsg');
  if (domestic && fill && msg){
    const pct = Math.min(100, Math.round(cart.total_price / FREE_SHIP * 100));
    fill.style.width = pct + '%';
    if (cart.item_count === 0){ msg.textContent = 'Free shipping on orders over ' + money(FREE_SHIP); }
    else if (cart.total_price >= FREE_SHIP){ msg.textContent = '🔥 Free shipping unlocked!'; fill.classList.add('done'); }
    else {
      // gq-15: jar-count nudge for AU carts made only of single 200g jars (still inside the domestic guard)
      const SINGLE_JARS = ['yum-yum-umami-seasoning-1','yumyum-meat-velvet','emperors-dust-dynasty-5-spice','shanghai-nights-soy-scallion'];
      const remaining = FREE_SHIP - cart.total_price;
      const jarLines = cart.items.filter(i => SINGLE_JARS.indexOf(i.handle) > -1);
      const jarsOnly = cart.items.length > 0 && jarLines.length === cart.items.length;
      if (jarsOnly){
        const unit = Math.min.apply(null, jarLines.map(i => i.final_price));
        const n = Math.max(1, Math.ceil(remaining / unit));
        msg.textContent = 'Add ' + n + ' more jar' + (n === 1 ? '' : 's') + ' to unlock FREE shipping';
      } else {
        msg.textContent = money(remaining) + ' away from free shipping';
      }
      fill.classList.remove('done');
    }
    const unlocked = cart.item_count > 0 && cart.total_price >= FREE_SHIP;
    if (unlocked && drawer.dataset.unlocked !== '1') document.dispatchEvent(new CustomEvent('yy:ship-unlocked'));
    drawer.dataset.unlocked = unlocked ? '1' : '0';
  }

  if (cart.item_count === 0){
    items.innerHTML=''; empty.hidden=false; upsell.hidden=true;
    const sug = document.getElementById('drawerSuggest');
    const d = drawer.dataset;
    sug.innerHTML = [
      {id:d.upsellUmami, name:'The Red Can', price:+d.upsellUmamiPrice},
      {id:d.upsellDuo, name:'Starter Duo', price:+d.upsellDuoPrice},
      {id:d.upsellFourpack, name:'Four-Pack of YUM', price:+d.upsellFourpackPrice},
    ].map(s=>`<button class="atc suggest-btn" data-variant-id="${s.id}">${s.name} · ${money(s.price)}</button>`).join('');
    bindAtc(sug);
    return;
  }
  empty.hidden = true;
  // Four-Pack tile — two different jobs, one element (gq-fourpack-multibuy, 2026-08-10).
  // (a) UNCHANGED: cart under the free-ship line with no Four-Pack in it -> the original
  //     "add a Four-Pack, it unlocks free shipping" pitch.
  // (b) NEW multi-buy nudge: the cart already holds exactly ONE Four-Pack -> offer a second.
  //     Measured 2026-08-10 over 1,080 orders / 30 days: 530 orders contain a Four-Pack and
  //     519 of them stop at exactly one, so this is the single biggest addressable moment in
  //     the cart. Both branches stay inside the `domestic` gate: the free-shipping wording is
  //     only true for AU standard, exactly as the ship bar above already is.
  const fourPackQty = cart.items.reduce((n,i)=> n + (i.handle==='four-pack-of-yum' ? i.quantity : 0), 0);
  const upLabel = document.getElementById('upsellLabel');
  const upSub   = document.getElementById('upsellSub');
  if (domestic && cart.total_price < FREE_SHIP && fourPackQty === 0){
    upsell.hidden = false;
    if (upLabel) upLabel.textContent = "That's the move";
    if (upSub) upSub.textContent = 'Every flavour \u00b7 unlocks free shipping';
  } else if (domestic && fourPackQty === 1){
    upsell.hidden = false;
    if (upLabel) upLabel.textContent = 'Double up';
    if (upSub) upSub.textContent = 'Gift one, keep one \u00b7 shipping still free';
  } else {
    upsell.hidden = true;
  }

  items.innerHTML = cart.items.map(i=>`
    <div class="drawer-item" data-key="${i.key}">
      <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2') : ''}" alt="" width="64" height="64" loading="lazy">
      <div class="di-info">
        <strong>${i.product_title}</strong>
        <div class="di-qty">
          <button class="qty-btn" data-key="${i.key}" data-qty="${i.quantity-1}" aria-label="Decrease quantity">−</button>
          <span>${i.quantity}</span>
          <button class="qty-btn" data-key="${i.key}" data-qty="${i.quantity+1}" aria-label="Increase quantity">+</button>
        </div>
      </div>
      <div class="di-price">${money(i.final_line_price)}</div>
    </div>`).join('');
  items.querySelectorAll('.qty-btn').forEach(b=>b.addEventListener('click',()=>{
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:b.dataset.key, quantity:parseInt(b.dataset.qty,10)})})
      .then(r=>r.json()).then(renderCart);
  }));
}

function refreshCart(){ return fetch('/cart.js').then(r=>r.json()).then(c=>{renderCart(c);return c;}); }

// ---- Add to cart ----
function bindAtc(scope){
  (scope||document).querySelectorAll('.atc[data-variant-id]').forEach(btn=>{
    if (btn.dataset.bound) return; btn.dataset.bound='1';
    btn.addEventListener('click',(e)=>{
      e.preventDefault(); e.stopPropagation();
      const id = parseInt(btn.dataset.variantId,10);
      if(!id) return;
      const original = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:id, quantity:1})})
        .then(r=>{ if(!r.ok) throw new Error(); return r.json(); })
        .then(()=>refreshCart())
        .then(()=>{ btn.textContent='Added ✓'; btn.classList.add('added'); openDrawer();
          document.dispatchEvent(new CustomEvent('yy:atc-added',{detail:{btn:btn}}));
          setTimeout(()=>{btn.textContent=original;btn.classList.remove('added');btn.disabled=false;},1200); })
        .catch(()=>{ btn.textContent='Try again'; btn.disabled=false; });
    });
  });
}
bindAtc();

// ---- Accordions ----
document.querySelectorAll('.acc-item').forEach(item=>{
  const head = item.querySelector('.acc-head');
  head.addEventListener('click',()=>{
    const open = item.classList.contains('open');
    item.closest('.accordion').querySelectorAll('.acc-item.open').forEach(o=>{
      o.classList.remove('open'); o.querySelector('.acc-head').setAttribute('aria-expanded','false');
    });
    if(!open){ item.classList.add('open'); head.setAttribute('aria-expanded','true'); }
  });
});

// ---- Filter chips ----
document.querySelectorAll('.chip-row').forEach(row=>{
  const targetSel = row.dataset.target;
  row.querySelectorAll('.chip').forEach(chip=>{
    chip.addEventListener('click',()=>{
      row.querySelectorAll('.chip').forEach(c=>{c.classList.remove('on');c.setAttribute('aria-pressed','false');});
      chip.classList.add('on'); chip.setAttribute('aria-pressed','true');
      const f = chip.dataset.filter;
      document.querySelectorAll(targetSel).forEach(card=>{
        const cats = (card.dataset.cat||'').split(' ');
        card.style.display = (f==='all'||cats.includes(f)) ? '' : 'none';
      });
    });
  });
});

// ---- PDP ladder ----
const ladder = document.querySelector('.ladder');
if (ladder){
  const priceEl = document.querySelector('.pdp-price');
  const noteEl = document.querySelector('.pdp-price-note');
  const cmpEl = document.querySelector('.pdp-compare');
  const atcBig = document.querySelector('.pdp-atc');
  ladder.querySelectorAll('.rung').forEach(r=>{
    r.addEventListener('click',()=>{
      ladder.querySelectorAll('.rung').forEach(x=>{x.classList.remove('on');x.setAttribute('aria-checked','false');});
      r.classList.add('on'); r.setAttribute('aria-checked','true');
      if(priceEl){ const from = priceEl.textContent; priceEl.textContent = r.dataset.price;
        if(from !== r.dataset.price) document.dispatchEvent(new CustomEvent('yy:price-change',{detail:{from:from, to:r.dataset.price}})); }
      if(noteEl) noteEl.textContent = r.dataset.note || '';
      if(cmpEl){ const c = r.dataset.compare || '';
        cmpEl.textContent = c; cmpEl.style.display = c ? '' : 'none'; }
      const mainImg = document.querySelector('.pdp-main-img');
      let rungImg = '';
      if(mainImg){ const tinThumb = document.querySelector('.thumb[data-mode="tin"]');
        const fallback = tinThumb ? tinThumb.dataset.src : '';
        rungImg = r.dataset.img || fallback;
        if(rungImg){ mainImg.src = rungImg; mainImg.className = 'pdp-main-img is-tin'; } }
      if(atcBig){ atcBig.dataset.variantId = r.dataset.variantId;
        atcBig.disabled = r.dataset.available==='false';
        atcBig.textContent = r.dataset.available==='false' ? 'Sold out' : 'Add to cart'; }
      // sync sticky bar to the selected rung
      const sName = document.getElementById('stickyName');
      const sPrice = document.getElementById('stickyPrice');
      const sBtn = document.getElementById('stickyAtcBtn');
      const sImg = document.getElementById('stickyImg');
      if(sName){ const nm = r.querySelector('.r-name'); if(nm) sName.textContent = nm.textContent; }
      if(sPrice) sPrice.textContent = r.dataset.price;
      if(sBtn){ sBtn.dataset.variantId = r.dataset.variantId;
        sBtn.disabled = r.dataset.available==='false';
        sBtn.textContent = r.dataset.available==='false' ? 'Sold out' : 'Add to cart'; }
      if(sImg && rungImg) sImg.src = rungImg;
    });
  });
}

// ---- PDP gallery ----
document.querySelectorAll('.thumb').forEach(t=>{
  t.addEventListener('click',()=>{
    document.querySelectorAll('.thumb').forEach(x=>x.classList.remove('on'));
    t.classList.add('on');
    const main = document.querySelector('.pdp-main-img');
    if(main){ main.src = t.dataset.src;
      main.className = 'pdp-main-img ' + (t.dataset.mode==='photo' ? 'is-photo' : 'is-tin'); }
  });
});

// ---- Sticky ATC bar (PDP) ----
const stickyBar = document.getElementById('stickyAtcBar');
const buyBoxAtc = document.querySelector('.pdp-atc');
if (stickyBar && buyBoxAtc){
  const sio = new IntersectionObserver(es=>{
    const e = es[0];
    stickyBar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
  },{threshold:0});
  sio.observe(buyBoxAtc);
}

// initial cart state
refreshCart();
})();

// ---- Stockist search ----
const stockistSearch = document.getElementById('stockistSearch');
if (stockistSearch){
  const cards = [...document.querySelectorAll('.stockist-card')];
  const none = document.getElementById('stockistNone');
  const apply = ()=>{
    const q = stockistSearch.value.trim().toLowerCase();
    const activeChip = document.querySelector('.chip-row[data-target=".stockist-card"] .chip.on');
    const st = activeChip ? activeChip.dataset.filter : 'all';
    let shown = 0;
    cards.forEach(c=>{
      const okState = st==='all' || (c.dataset.state===st);
      const okText = !q || c.dataset.search.includes(q);
      const show = okState && okText;
      c.style.display = show ? '' : 'none';
      if (show) shown++;
    });
    if (none) none.hidden = shown > 0;
  };
  stockistSearch.addEventListener('input', apply);
  document.querySelectorAll('.chip-row[data-target=".stockist-card"] .chip').forEach(ch=>ch.addEventListener('click', ()=>setTimeout(apply,0)));
}

// ---- Mobile menu ----
const menuToggle = document.getElementById('menuToggle');
const mobileNav = document.getElementById('mobileNav');
if (menuToggle && mobileNav){
  menuToggle.addEventListener('click', ()=>{
    const open = mobileNav.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', open);
    menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });
  mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click', ()=>{
    mobileNav.classList.remove('open');
    menuToggle.setAttribute('aria-expanded','false');
  }));
}

// ---- Tap-to-boop on product imagery ----
document.querySelectorAll('.hero-can,.pdp-main-img,.flavour-hero img,.p-hero img,.edu-can,.bundle-card img').forEach(el=>{
  el.addEventListener('pointerdown',()=>{
    el.classList.remove('boop'); void el.offsetWidth; el.classList.add('boop');
  });
  el.addEventListener('animationend',(e)=>{ if(e.animationName==='boop') el.classList.remove('boop'); });
});

// ---- Social feed: play visible videos + gentle auto-scroll ----
const feedTrack = document.getElementById('feedTrack');
if (feedTrack){
  const vids = [...feedTrack.querySelectorAll('video')];
  const vio = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    if (e.isIntersecting){
      if (!v.src && v.dataset.src){ v.src = v.dataset.src; v.load(); }
      v.play().catch(()=>{});
    } else { v.pause(); }
  }), {root: null, rootMargin: '250px', threshold: .1});
  vids.forEach(v => vio.observe(v));

  ['pointerdown','touchstart'].forEach(ev => feedTrack.addEventListener(ev, ()=>{ feedTrack.classList.add('paused'); }));
  ['pointerup','touchend','touchcancel'].forEach(ev => feedTrack.addEventListener(ev, ()=>{ setTimeout(()=>{ feedTrack.classList.remove('paused'); }, 1800); }));
}

// ---- US visitor callout (matches live-site heuristic incl. ?us_preview) ----
const usCallout = document.getElementById('usCallout');
if (usCallout){
  const isUS = () => {
    if (/[?&]us_preview/i.test(location.search)) return true;
    try {
      const tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '');
      const lang = (navigator.language || '').toLowerCase();
      const US = ['America/New_York','America/Detroit','America/Kentucky','America/Indiana','America/Indianapolis','America/Chicago','America/Menominee','America/Denver','America/Boise','America/Phoenix','America/Los_Angeles','America/Anchorage','America/Adak','America/Juneau','America/Sitka','America/Metlakatla','America/Yakutat','America/Nome','America/North_Dakota','Pacific/Honolulu'];
      return US.some(z => tz.indexOf(z) === 0) || lang === 'en-us';
    } catch(e){ return false; }
  };
  if (isUS()) usCallout.hidden = false;
}

// ---- Quiz popup (10% first-order) ----
(function(){
  const pop = document.getElementById('quizPop');
  if (!pop) return;
  const overlay = document.getElementById('quizOverlay');
  const s1 = document.getElementById('quizStep1'), s2 = document.getElementById('quizStep2'), s3 = document.getElementById('quizStep3');
  const KEY_DONE = 'yy-quiz-done', KEY_SNOOZE = 'yy-quiz-snooze';
  const qs = new URLSearchParams(location.search);
  const force = qs.has('yy_quiz');
  const justSubscribed = qs.has('yy_sub') || qs.get('customer_posted') === 'true';

  function show(step){
    [s1,s2,s3].forEach(s => s.hidden = true);
    step.hidden = false;
    pop.hidden = false; overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function hide(){
    pop.hidden = true; overlay.hidden = true;
    document.body.style.overflow = '';
  }
  function snooze(){ try{ localStorage.setItem(KEY_SNOOZE, Date.now()); }catch(e){} hide(); }

  document.getElementById('quizClose').addEventListener('click', snooze);
  document.getElementById('quizDismiss').addEventListener('click', snooze);
  overlay.addEventListener('click', snooze);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !pop.hidden) snooze(); });

  document.querySelectorAll('.quiz-ans').forEach(b => b.addEventListener('click', () => {
    document.getElementById('quizTags').value = 'newsletter,' + b.dataset.tag;
    document.getElementById('quizReturn').value = location.pathname + '?yy_sub=1';
    show(s2);
    setTimeout(()=>document.getElementById('quizEmail').focus(), 100);
  }));

  if (justSubscribed){
    try{ localStorage.setItem(KEY_DONE, '1'); }catch(e){}
    show(s3);
    return;
  }

  let done = null, snoozedAt = 0;
  try{ done = localStorage.getItem(KEY_DONE); snoozedAt = +(localStorage.getItem(KEY_SNOOZE) || 0); }catch(e){}
  const snoozed = Date.now() - snoozedAt < 14*24*3600*1000;
  const onQuietPage = /\/cart|\/checkout|\/pages\/legacy/.test(location.pathname);

  if (force){ show(s1); return; }
  if (done || snoozed || onQuietPage) return;

  let shown = false;
  const trigger = () => { if (!shown){ shown = true; show(s1); } };
  setTimeout(trigger, 9000);
  addEventListener('scroll', function onScroll(){
    if (scrollY > document.body.scrollHeight * 0.35){ removeEventListener('scroll', onScroll); trigger(); }
  }, {passive: true});
})();
